import { type KeyboardEvent as ReactKeyboardEvent, useRef } from 'react';
import { useIntl } from 'react-intl';

import { DownloadIcon } from '@dynatrace/strato-icons';

import { ChartToolbarRenderer } from '../../../core/components/toolbar/ChartToolbarRenderer.js';
import { TOOLBAR_MESSAGES } from '../../../core/components/toolbar/messages.js';
import { useA11yToolbarTabIndex } from '../../../core/hooks/useA11yToolbarTabIndex.js';
import { useTreeMapRawData } from '../../context/TreeMapRawDataContext.js';
import { buildAndDownloadCsv } from '../../utils/build-and-download-csv.js';

export const TreeMapDownloadDataButton = () => {
  const downloadDataButtonRef = useRef<HTMLButtonElement>(null);
  const intl = useIntl();
  const tabIndex = useA11yToolbarTabIndex('download');
  const { tree } = useTreeMapRawData();

  /** Handles the download button when event keydown.*/
  const handleDownloadDataKeyboard = (event: ReactKeyboardEvent) => {
    if (event.key === 'Enter') {
      buildAndDownloadCsv(tree);
    }
  };

  /** Handles the download button when clicked. */
  const handleDownloadDataToolbar = () => {
    buildAndDownloadCsv(tree);
  };

  return (
    <ChartToolbarRenderer.Control
      ref={downloadDataButtonRef}
      prefixIcon={<DownloadIcon />}
      tooltipText={intl.formatMessage(TOOLBAR_MESSAGES.downloadData)}
      testId="map-toolbar-download"
      onKeyDown={handleDownloadDataKeyboard}
      onClick={handleDownloadDataToolbar}
      tabIndex={tabIndex}
    />
  );
};
